import AjaxForm from "../AjaxForm";

/**
 * @description Notify Me Subscribe implementation
 */
export default class NotifyMe extends AjaxForm {
  prefs() {
    return {
      emailInput: 'notifyMe',
      productInput: 'notifyMeProductId',
      active: 'alertActive',
      errorMessage: 'errorFeedback',
      submitButton: 'submitButton',
      submittedButtonClass: 'b-notifyMe__button--submitted',
      successFeedback: 'successFeedback',
      ...super.prefs(),
    };
  }
  init() {
    this.ref(this.prefs().submitButton).disable();
    this.eventBus().on('notifyMe.submitButtonState', 'submitButtonState');
    this.eventBus().on('product.history.updated', 'onProductUpdated');
    this.submittedForIds = {};
  }

  onProductUpdated(product) {
    this.getProductIdInput().value = product.id;

    if (
      this.lastReceivedData &&
      this.lastReceivedData.productIdNotifyMe !== product.id
    ) {
      this.ref(this.prefs().emailInput).validate({ focusCleanup: true });
    }

    if (this.submittedForIds[product.id]) {
      this.ref(this.prefs().submitButton).disable();
      this.ref(this.prefs().submitButton).addClass(
        this.prefs().submittedButtonClass
      );
      this.ref(this.prefs().emailInput).hide();
      this.ref(this.prefs().active).show();
    } else {
      this.ref(this.prefs().submitButton).enable();
      this.ref(this.prefs().submitButton).removeClass(
        this.prefs().submittedButtonClass
      );
      this.ref(this.prefs().emailInput).show();
      this.ref(this.prefs().active).hide();
      this.ref(this.prefs().successFeedback).hide();
    }
  }

  afterSubmission() {
    super.afterSubmission();
    if (this.lastReceivedData && this.lastReceivedData.success) {
      this.ref(this.prefs().submitButton).disable();
      this.ref(this.prefs().emailInput).hide();
    }
  }

  getProductIdInput() {
    return this.ref(this.prefs().productInput).get().querySelector('input');
  }

  /**
   * @param {Object} data submitted data
   */
  onSubmitted(data) {
    this.lastReceivedData = data;
    var productId = this.getProductIdInput().value;

    if (data.success) {
      this.submittedForIds[productId] = true;
      this.eventBus().emit('notifyMe.submitted', data);
      this.ref(this.prefs().submitButton).addClass(
        this.prefs().submittedButtonClass
      );
      this.ref(this.prefs().submitButton).disable();
      this.ref(this.prefs().contentAssetSuccess).show();
      this.ref(this.prefs().successFeedback).show();
    }

    if (data.error) {
      this.ref(this.prefs().contentAssetSuccess).hide();
      this.ref(this.prefs().emailInput).setError(data.msg);
    }

    return data;
  }

  /**
   * @param {Boolean} isActiveState button state
   */
  submitButtonState(isActiveState) {
    if (
      isActiveState &&
      !this.submittedForIds[this.getProductIdInput().value]
    ) {
      this.ref(this.prefs().submitButton).enable();
    } 
  }

  handleSubmit() {
    // avoid request when submit button is disabled (e.g. press Enter on Safari Mac)
    if (this.ref(this.prefs().submitButton).isDisabled()) {
      return;
    }

    this.ref(this.prefs().contentAssetSuccess).show();
    this.eventBus().emit('email.submitted', this.getFormFields());
    super.handleSubmit();
  }
}